<template>
	<div>
		<Modal :onClose="onClose">
			<div slot="header">
        <span v-if="isValidToCreateChannel && !statusMessage.isSaved">New Channel</span>
      </div>
      <!-- Error -->
			<div class="form-error" v-if="!isValidToCreateChannel">
				<MessageContainer>
					<div slot="header">
						<i class="fas fa-exclamation-triangle" />
					</div>
					<div slot="detail">
						<div class="title">
							Sorry, there are no services for applied to channel. Please contact <a href="mailto:support@byteark.com">support@byteark.com</a> for create service
						</div>
					</div>
				</MessageContainer>
			</div>
      <!-- Success : Get subscribers url  -->
      <div class="form-message" v-if="isValidToCreateChannel && statusMessage.isSaved">
        <MessageContainer>
          <div slot="header">
            <i class="fas fa-check-circle"></i>
          </div>
          <div slot="detail">
            <div class="title">
              Pass <strong>Subscribers URL</strong> into options of <br/> ByteArk Firework Plugin
            </div>
            <div class="input-group mb-3 pl-4 pr-4 pt-2">
              <input type="url" class="form-control" :value="subscriberUrl" readonly>
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary"
                  type="button"
                  :v-clipboard="subscriberUrl">{{buttonCopyText}}</button>
              </div>
            </div>
          </div>
        </MessageContainer>
      </div>
      <!-- Form -->
			<form class="form-multiple-step" v-if="isValidToCreateChannel && !statusMessage.isSaved"
				v-on:submit.prevent="onSubmitChannel">
				<!-- Form Nav -->
				<div class="form-step-nav">
					<div class="nav-item" :class="{'active': isCurrentStep(1)}" @click.stop="changeStep(1)">
						<span class="label">1</span>
						<div class="title">Fill Information</div>
					</div>
					<div class="nav-item" :class="{'active': isCurrentStep(2)}"  @click.stop="prevFromNav">
						<span class="label">2</span>
						<div class="title">Choose Service</div>
					</div>
				</div>
				<!-- Step 1: Fill info -->
				<div class="form-step" v-if="isCurrentStep(1)">
					<div class="form-detail">
						<div class="row">
							<div class="col-md-12">
								<form-group :error="getError(error, 'name')">
									<label for="name">Name</label>
									<input type="text"
										class="form-control"
										placeholder="Name"
										v-model="channel.name"
										autofocus required />
								</form-group>
								<form-group :error="getError(error, 'description')">
									<label for="name">Description</label>
									<input type="text"
										class="form-control"
										placeholder="Description"
										v-model="channel.description" />
								</form-group>
								<form-group :error="getError(error, 'streamUrl')">
									<label for="name">Stream Url</label>
									<input type="url"
										class="form-control"
										placeholder="Stream Url"
										v-model="channel.streamUrl"
										@blur="isValidURL(channel.streamUrl)"
										required />
								</form-group>
							</div>
						</div>
					</div>
					<div class="form-actions">
						<div class="row">
							<div class="col-md-12">
								<button type="button"
									class="btn btn-success btn-block"
									@click.stop="changeStep(2)"
									:disabled="!isValidNextStep">Next</button>
							</div>
						</div>
					</div>
				</div>
				<!-- Step 2: Choose Service -->
				<div class="form-step" v-if="isCurrentStep(2)">
					<div class="form-error" v-if="statusMessage.error">
						<div class="alert alert-danger" role="alert">
						  <span>Sorry, Channel can't be created</span>
						  <ul>
						  	<li v-for="(error, index) in statusMessage.error" :key="index">{{error}}</li>
						  </ul>
						</div>
					</div>
					<div class="form-detail">
						<div class="row">
							<div class="col-md-12">
								<ChooseServiceList
									v-model="channel.serviceId"
									:services="services" />
							</div>
						</div>
					</div>
					<div class="form-actions">
						<div class="row">
							<div class="col-md-12">
								<button type="submit"
									class="btn btn-success btn-block"
									:disabled="!isValidSubmit">Create</button>
							</div>
						</div>
					</div>
				</div>
			</form>
		</Modal>
	</div>
</template>

<script>
/* eslint object-shorthand: "off" */
import _ from 'lodash';
import { getError, isValidURL } from '@/modules/utilities';
import ChooseServiceList from '@/components/parts/service/ChooseServiceList';
import Modal from '@/components/elements/Modal';
import FormGroup from '@/components/elements/FormGroup';
import MessageContainer from '@/components/elements/MessageContainer';

export default {
	props: ['onClose', 'onSubmit', 'statusMessage', 'services'],
	components: {
		Modal,
		FormGroup,
		MessageContainer,
		ChooseServiceList,
	},
	data() {
		return {
			step: 1,
			channel: {
				name: null,
				description: null,
				streamUrl: null,
				serviceId: null,
			},
      buttonCopyText: 'Copy',
			error: {
				name: null,
				description: null,
				streamUrl: null,
			},
			minStep: 1,
			maxStep: 2,
		};
	},
	computed: {
    subscriberUrl() {
      return _.get(this.statusMessage, 'payload.subscriberUrl');
    },
		isValidToCreateChannel() {
			return this.services && this.services.length > 0;
		},
		isValidNextStep() {
			return this.channel.name &&
			this.channel.streamUrl &&
			this.isValidURL(this.channel.streamUrl) &&
			!this.statusMessage.isSaving;
		},
		isValidSubmit() {
			return this.channel.name &&
			this.channel.streamUrl &&
			this.channel.serviceId &&
			!this.statusMessage.isSaving;
		},
	},
	watch: {
		'channel.streamUrl'(newVal) {
			if (this.isValidURL(newVal)) {
				this.error.streamUrl = '';
			} else {
				this.error.streamUrl = 'invalid url format';
			}
		},
	},
	methods: {
		getError,
		isValidURL,
		isCurrentStep(step) {
			return this.step === step;
		},
		changeStep(step) {
			if (step > this.maxStep) {
				this.step = this.maxStep;
			} else if (step < this.minStep) {
				this.step = this.minStep;
			} else {
				this.step = step;
			}
		},
		nextStep() {
			if (this.step === 1) {
				this.step += 1;
			}
		},
		prevFromNav() {
			if (this.isValidNextStep) {
				this.nextStep();
			}
		},
		onSubmitChannel() {
			this.onSubmit(this.channel);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/themes/variables.scss';
</style>



// WEBPACK FOOTER //
// src/components/parts/channel/CreateChannelModal.vue